var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modify-room-overview" }, [
    _c("div", { staticClass: "modify-room-overview__date" }, [
      _c("div", { staticClass: "modify-room-overview__date-label" }, [
        _vm._v("\n      " + _vm._s(_vm.ModifyReservationDateTitle) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modify-room-overview__date-entry" }, [
        _c("div", { staticClass: "modify-room-overview__day" }, [
          _vm._v(_vm._s(_vm.dayIn)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modify-room-overview__date-info" }, [
          _vm._v(_vm._s(_vm.startDate)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modify-room-overview__date-entry" }, [
        _c("div", { staticClass: "modify-room-overview__day" }, [
          _vm._v(_vm._s(_vm.dayOut)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modify-room-overview__date-info" }, [
          _vm._v(_vm._s(_vm.endDate)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modify-room-overview__date-arrow" }, [
      _vm._v("→"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modify-room-overview__hours" }, [
      _c("div", { staticClass: "modify-room-overview__check-in" }, [
        _c("div", { staticClass: "modify-room-overview__label" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.ModifyReservationCheckInTitle) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modify-room-overview__time" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.tc("booking.after")) +
              " " +
              _vm._s(_vm.timeIn12hFormat(_vm.checkInTime)) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modify-room-overview__check-out" }, [
        _c("div", { staticClass: "modify-room-overview__label" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.ModifyReservationCheckOutTitle) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modify-room-overview__time" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.tc("booking.before")) +
              " " +
              _vm._s(_vm.timeIn12hFormat(_vm.checkOutTime)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        class:
          "modify-room-overview__room " +
          (!_vm.isMultiRoomReservation ? "single" : "multi-room"),
      },
      [
        _c("div", { staticClass: "modify-room-overview__label" }, [
          !_vm.isMultiRoomReservation
            ? _c("span", [_vm._v(_vm._s(_vm.ModifyReservationRoomTitle))])
            : _vm._e(),
          _vm._v(" "),
          _vm.isMultiRoomReservation
            ? _c("span", [_vm._v(_vm._s(_vm.ModifyReservationRoomsTitle))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm._l(_vm.reservations, function (reservation) {
          return _c(
            "div",
            { key: reservation.id, staticClass: "modify-room-overview__type" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.ModifyReservationRoomTitle) +
                  " " +
                  _vm._s(reservation.roomNumberOrder) +
                  ":\n      " +
                  _vm._s(reservation.roomStays[0].roomName) +
                  "\n    "
              ),
            ]
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modify-room-overview__policies" },
      [
        _c("toggle-details", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var opened = ref.opened
                var toggle = ref.toggle
                var isMounted = ref.isMounted
                return _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticClass: "detailed-content",
                      class: [{ opened: opened }],
                    },
                    [
                      _c("div", { staticClass: "activator" }, [
                        _c(
                          "div",
                          {
                            staticClass: "modify-room-overview__policies-label",
                            attrs: {
                              role: "button",
                              tabindex: "0",
                              "aria-expanded": opened ? "true" : "false",
                            },
                            on: {
                              click: toggle,
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return toggle($event)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return toggle($event)
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "modify-room-overview__policies-block",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modify-room-overview__policies-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.ModifyReservationPoliciesTitle
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  class: opened ? "icon-minus" : "icon-add",
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modify-room-overview__policies-list",
                          class: [{ opened: opened }],
                        },
                        [
                          _c(
                            "transition-group",
                            { attrs: { name: "expand-y" } },
                            [
                              opened
                                ? _c(
                                    "div",
                                    {
                                      key: "modify-room-overview__policies-list",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "modify-room-overview__policies-label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.ModifyReservationGuaranteePolicyTitle
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("ul", {
                                        class:
                                          "modify-room-overview__policies-content " +
                                          _vm.indentGuaranteePolicyHtmMarkup,
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.guaranteePolicy
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }